module.exports = __webpack_public_path__ + "img/bg-image-21.cffe9588.jpg";